// extracted by mini-css-extract-plugin
export default {"zoomModal":"r2-z"};